import { BookmarkIcon, Pencil1Icon, TrashIcon } from "@radix-ui/react-icons";
import { useState } from "react";
import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import { Lists } from "../../components/common/Lists";
import TableComponent from "../../components/common/Tables";
import { useAppDispatch } from "../../hooks/hooks";
import { useGetClassesQuery } from "../../hooks/useGetClassesQuery";
import { setClassData } from "../../redux/slices/school/classes";
import { routes } from "../../routes";
import { updateClass } from "../../services/school/class/updateClass";
import { ClassType } from "../../types/Class";
import { Key_classes, PAGE_NUMBER, PAGE_SIZE } from "../../utils/constants";

const columnNamesMap: { [key: string]: string } = {
  description: 'Turma',
  academicYear: 'Ano Académico',
};
export const Classes = () => {
  const [currentPage, setCurrentPage] = useState(PAGE_NUMBER);
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const queryClient = useQueryClient();
  const { data, status } = useGetClassesQuery({
    PageNumber: currentPage, PageSize: pageSize, SearchTerm: searchTerm,
    IdAcademicYear: '',
    IdCourse: '',
    //  Regime:'',
    // Semester:'',
    // Level:'',



  });
  const mutationDeleteClass = useMutation(updateClass, {
    onSuccess: () => {
      queryClient.invalidateQueries(Key_classes);
      toast.success('Turma apagada');
    },
    onError: () => {
      toast.error("Erro ao apagar Turma.")
    }
  });
  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };
  const handlePageSizeChange = (size: number) => {
    setPageSize(size);
    setCurrentPage(PAGE_NUMBER);
  };

  const handleSearch = (term: string) => {
    setSearchTerm(term);
    setCurrentPage(1);
  };
  const handleClickCreate = (event: any): void => {
    navigate(routes.createClass)
  }
  const handleEdit = (_class: ClassType) => {
    dispatch(setClassData(_class));
    navigate(routes.updateClass)
  };
  const handleDelete = (_class: ClassType) => {
    _class.status = false;
    mutationDeleteClass.mutateAsync(_class)
  };
  const handleLinkTeacherAndSubjects = (_class: ClassType) => {
    dispatch(setClassData(_class));
    navigate(routes.assignTeacherClassesSubjects)
  };

  const handleManageStudents = (_class: ClassType) => {
    dispatch(setClassData(_class));
    navigate(routes.manageClassStudents)
  };
  const handleManageSchedule = (_class: ClassType) => {
    dispatch(setClassData(_class));
    navigate(routes.manageSchedule)
  };
  const options = data?.items.map(() => [
    {
      label: 'Editar',
      onClick: (_class: ClassType) => handleEdit(_class),
      icon: <Pencil1Icon />
    },
    {
      label: 'Excluir',
      onClick: (_class: ClassType) => handleDelete(_class),
      icon: <TrashIcon />
    },
    {
      label: 'Gerir Estudantes',
      onClick: (_class: ClassType) => handleManageStudents(_class),
      icon: <BookmarkIcon />
    },
    {
      label: 'Vincular docente X disciplina',
      onClick: (_class: ClassType) => handleLinkTeacherAndSubjects(_class),
      icon: <BookmarkIcon />
    },
    {
      label: 'Gerir horario',
      onClick: (_class: ClassType) => handleManageSchedule(_class),
      icon: <BookmarkIcon />
    }
  ]) || [];
  return (
    <Lists
      status={status}
      TableComponent={() =>
           <TableComponent
            columns={Object.keys(columnNamesMap)}
            items={data?.items}
            options={options}
            columnNamesMap={columnNamesMap}
            totalPages={data?.totalPages || 1}
            currentPage={currentPage}
            onPageChange={handlePageChange}
            pageSize={pageSize}
            onPageSizeChange={handlePageSizeChange} 
            onSearch={handleSearch}
            search={searchTerm}
            totalItems={data?.totalItems || 0}
          />
      }
      handleClickCreate={handleClickCreate}
    />
  );
}
